export function uuid() {
    return `${uuidChar()}${uuidChar()}-${uuidChar()}-${uuidChar()}-${uuidChar()}-${uuidChar()}${uuidChar()}${uuidChar()}`;
}

function uuidChar() {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
}
